import { gql, useMutation } from '@apollo/client'
import { IChannel, IChannelReplyInput } from '@dtos/Channel'

export const CHANNEL_REPLY = gql`
  mutation ChannelReply($channelId: ID!, $text: String!) {
    channelReply(
      input: {
        channelId: $channelId
        text: $text
        clientMutationId: "channel-reply"
      }
    ) {
      channel {
        id
        subject
        updatedAt
        messages {
          id
          text
          createdAt
          sender {
            id
            fullName
            firstName
            lastName
            email
            avatarUrl
          }
        }
      }
      errors
    }
  }
`

interface IChannelReplyResult {
  channelReply: {
    channel: IChannel | null
    errors: string[]
  }
}

export const useChannelReply = () => {
  const [reply, { loading, error }] = useMutation<IChannelReplyResult>(
    CHANNEL_REPLY,
    {
      refetchQueries: ['GetChannel', 'GetChannels'],
      awaitRefetchQueries: true,
    },
  )

  const handleReply = async (input: IChannelReplyInput) => {
    const response = await reply({ variables: input })
    return response.data?.channelReply
  }

  return { handleReply, loading, error }
}
